import { resolveTranslationKey } from './carrouselTranslationKeyResolver';

export function CarrouselAddButtonButtonViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: false,
    angularTemplate: require('./CarrouselAddButtonButtonView.html'),

    initialize: function() {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);
    },

    updateBox: function() {
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
    },
    
    resolveTranslationKey: function (key) {
      return resolveTranslationKey(this.getParentType(), key);
    },

    addChildClicked: function(evt) {
      if (!this.angularScope.elementData.disabled) {
        services.QuickRepliesFactory.createUniqueId(companyId, siteId, scenarioId)
        .then(response => {
          this.getParentView().addChildClicked(response.data.id, this.angularScope.elementData.carrouselElementId);
        }, 
        services.AlertingFactory.httpErrorHandler());
      }
    },

  });
}
